import React from 'react'
import icon from './svgs/statistics_grow.svg'
import { BaseIcon } from './_base'

export const StatisticsGrowIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
